<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Medicos',

    metaInfo: { title: 'Patólogos Clínicos Certificados' },
    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        //'ConvocatoriaCertificacion',
       // 'ConvocatoriaRecertificacion',
       // 'CitatorioAsamblea',
        'medicos-certificados',
        'info-alt',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'pricing-plans',
      },
    },
  }
</script>
